<template>
  <div class="left">
    <div class="question">
      <p class="title">您可以这样问：</p>
      <div class="scroll-container">
        <ul class="scroll-content" :style="{ '--scroll-time': scrollTime }">
          <li
            class="item flex"
            v-for="(item, index) in questions.concat(questions)"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Left",
  props: {},
  data() {
    return {
      questions: window.config.questions || [],
      scrollTime: window.config.scrollTime || "30s",
    };
  },
};
</script>

<style lang="less" scoped>
@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%); /* 向上滚动一半 */
  }
}
.left {
  position: relative;
  // flex: 1;
  width: 23%;
  align-items: center;
  .question {
    position: absolute;
    left: 0%;
    width: 100%;
    bottom: 15vh;
    height: 100%;
    background-image: url("../assets/images/lead-bg-50.png");
    background-size: contain;
    background-position: bottom;
    background-repeat: no-repeat;
    overflow: hidden;
  }
  .scroll-container {
    position: absolute;
    bottom: 56px;
    height: 320px;
    padding: 0 30px;
    overflow-y: hidden;
  }
  .scroll-content {
    box-sizing: border-box;
    margin-top: 0;
    animation: scroll var(--scroll-time) linear infinite;
  }
  .title {
    position: absolute;
    bottom: 384px;
    padding-left: 22px;
    font-weight: 600;
    font-size: 22px;
    color: #fff1a7;
    line-height: 32px;
    margin: 0;
    margin-bottom: 20px;
  }
  li {
    position: relative;
    font-weight: 600;
    font-size: 19px;
    color: #ffffff;
    line-height: 30px;
    padding: 15px 0 0 24px;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
    letter-spacing: 1px;
  }
  li::before {
    content: "";
    position: absolute;
    left: -10px;
    width: 6px;
    height: 6px;
    background: #fff;
    margin: 12px 16px 0;
    border-radius: 50%;
  }
}
</style>
